import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    localStorage: Storage;

    constructor() {
        this.localStorage = window.localStorage;
        if (!window.localStorage) {
            throw new Error('Local Storage is not supported');
        }
    }

    setItem(key: string, data: any): void {
        if (this.localStorage) {
            try {
                const stringData: string = JSON.stringify(data);
                this.localStorage.setItem(key, stringData);
            } catch (error) {
                console.error(error);
            }
        }
    }

    getItem(key: string): any {
        if (this.localStorage) {
            try {
                return JSON.parse(this.localStorage.getItem(key));
            } catch (error) {
                console.error(error);
            }
        }
    }

    removeItem(key: string): void {
        if (this.localStorage) {
            try {
                this.localStorage.removeItem(key);
            } catch (error) {
                console.error(error);
            }
        }

    }

    clearAll(): void {
        if (this.localStorage) {
            try {
                this.localStorage.clear();
            } catch (error) {
                console.error(error);
            }
        }
    }
}
